export default __webpack_public_path__ + "153111c2a926f51004e66740f43df608.png";